import { toSubjectsForApi } from './subjects';

// Editing content must never replace a tool's saved regions with its editor's
// profile. Metadata is sent only for explicitly edited settings.
export const toolSettingsPatch = (changes, current, subjectsList) => {
  const patch = {};
  const supplied = field => Object.prototype.hasOwnProperty.call(changes, field) && changes[field] !== undefined;
  if (supplied('title')) patch.title = changes.title;
  const settings = ['years', 'subjects', 'taskTypes', 'responseTypes'].filter(supplied);
  if (settings.length) {
    if (!Array.isArray(current.metadata?.states)) {
      throw new Error('Reload this tool before changing its settings.');
    }
    patch.metadata = { ...current.metadata };
    settings.forEach(field => {
      patch.metadata[field] = field === 'subjects'
        ? toSubjectsForApi(changes[field], subjectsList)
        : changes[field];
    });
  }
  return patch;
};
